import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-inactive-account-dialog',
    templateUrl: './inactive-account-dialog.component.html',
    styleUrls: ['./inactive-account-dialog.component.scss']
})
export class InactiveAccountDialogComponent {

    userDetails: userDetail;

    constructor(
        public dialogRef: MatDialogRef<InactiveAccountDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
    ) {
        this.userDetails = data;
    }
}

interface userDetail {
    orgDesc: string,
    year: string,
    versionId: string,
}